import React from "react";
import ReactDOM from "react-dom";
import "assets/css/material-dashboard-react.css?v=1.9.0";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap';
import "assets/css/styles.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "react-phone-input-mui/dist/style.css";
import "react-multi-carousel/lib/styles.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Import css theme
import "assets/css/theme/owl.theme.default.min.css";
import "assets/css/theme/owl.carousel.min.css";
import "assets/css/theme/animate.css";
import "assets/css/theme/flaticon.css";
import "assets/css/theme/nice-select.css";
import "assets/css/theme/magnific-popup.css";
import "assets/css/theme/meanmenu.css";
import "assets/css/theme/style.css";
import "assets/css/theme/responsive.css";

import "jquery/dist/jquery.min.js"

import { registerServiceWorker } from './serviceWorker'

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));

registerServiceWorker();
